import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';

import '../App.css';

// Import images
import LogoImg from '@/assets/static-landing-pages/Logo.png';
import ThankYouImg from '@/assets/static-landing-pages/thank-you.png';

function ThankYou() {
	// Initialize Meta Pixel and track conversion
	useEffect(() => {
		ReactPixel.init('1106122598296027');
		ReactPixel.pageView();
		ReactPixel.track('Lead'); // Track conversion event
	}, []);
	return (
		<div className="min-h-screen bg-white w-full flex flex-col lg:flex-row items-center lg:items-stretch justify-center lg:justify-start">
			{/* Left Section - Laptop Visual */}
			<div className="w-3/4 lg:w-1/2 h-64 lg:h-auto relative overflow-hidden bg-gray-100 order-1 lg:order-1 mx-auto lg:mx-0 rounded-3xl lg:rounded-none">
				<div className="h-full flex items-center justify-center">
					<img
						src={ThankYouImg}
						alt="Thank you robot illustration"
						className="w-full h-full object-cover"
					/>
				</div>

				{/* Organic curved shape - hidden on mobile */}
				<div className="hidden lg:block absolute right-0 top-0 w-16 h-full bg-white transform translate-x-2 rounded-l-full"></div>
			</div>

			{/* Right Section - Text and CTA */}
			<div className="w-full lg:w-1/2 flex flex-col justify-center items-center lg:items-start p-6 sm:p-8 lg:p-12 bg-white order-2 lg:order-2">
				<div className="max-w-md w-full text-center lg:text-left">
					<h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 lg:mb-6 text-purpleBrand-500">
						Thank you for signing up!
					</h1>

					<h2 className="text-xl sm:text-2xl font-medium text-gray-800 mb-4 lg:mb-6">
						There's just one more step
					</h2>

					<p className="text-base sm:text-lg text-[#091C53] mb-6 lg:mb-8 leading-relaxed font-semibold">
						Click on the button below to create an account to ensure you get an
						early access invite to Haggle events.
					</p>

					<button
						className="w-full sm:w-3/4 lg:w-2/3 bg-purpleBrand-500 text-white py-3 sm:py-3 rounded-3xl font-medium text-sm sm:text-base transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 cursor-pointer"
						onClick={() =>
							window.open(
								`${import.meta.env.VITE_FRONTEND_URL}/auth/customer-sign-up/`,
								'_blank',
							)
						}
					>
						Create an Account For Free
					</button>
				</div>

				{/* Haggle Logo */}
				<div className="mt-8 lg:mt-12 flex justify-center lg:justify-end lg:pe-40">
					<div className="flex items-center">
						<img
							src={LogoImg}
							alt="Haggle"
							className="h-8 sm:h-10 lg:h-12 w-auto cursor-pointer hover:opacity-80 transition-opacity duration-200"
							onClick={() => (window.location.href = '/welcome')}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ThankYou;
